import axios from "axios";

const configuredPortalBaseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL ||
  `${window.location.protocol}//${window.location.host}`;

const portalBaseUrl = configuredPortalBaseUrl.includes("localhost")
  ? "http://paiy.local"
  : configuredPortalBaseUrl.replace(/\/$/, "");

const loansBackendEntryUrl =
  process.env.REACT_APP_LOANS_API_BASE_URL ||
  `${portalBaseUrl}/loans-backend/public/index.php`;

const loansBackendClient = axios.create({
  baseURL: loansBackendEntryUrl,
  headers: { "Content-Type": "application/json" },
});

const getPortalActorId = () => {
  const storedActorId = localStorage.getItem("authUser");
  if (storedActorId) {
    return storedActorId;
  }

  try {
    const storedUser = JSON.parse(sessionStorage.getItem("user") || "null");
    return storedUser?.userid || storedUser?.id || "";
  } catch (_error) {
    return "";
  }
};

const get = async (route, query = {}) => {
  const sessionId = localStorage.getItem("sessionID");
  const actorId = getPortalActorId();
  const response = await loansBackendClient.get("", {
    params: { route, ...query },
    headers: sessionId && actorId
      ? { Authorization: `PAIY-Session ${actorId}:${sessionId}` }
      : undefined,
  });

  return Array.isArray(response?.data?.data) ? response.data.data : [];
};

const getObject = async (route, query = {}) => {
  const sessionId = localStorage.getItem("sessionID");
  const actorId = getPortalActorId();
  const response = await loansBackendClient.get("", {
    params: { route, ...query },
    headers: sessionId && actorId
      ? { Authorization: `PAIY-Session ${actorId}:${sessionId}` }
      : undefined,
  });
  return response?.data?.data || {};
};

export const getEarlyWarningDashboard = async (currency = "") =>
  getObject("/api/early-warning/dashboard", currency ? { currency } : {});
export const getLoanPortfolioReportingDashboard = (filters = {}) => getObject("/api/loan-portfolio-reporting/dashboard", filters);
export const listLoanSchemes = (filters = {}) => get("/api/loan-schemes", filters);
export const getLoanSchemeVersion = (id) => getObject(`/api/loan-scheme-versions/${encode(id)}`);
export const createLoanSchemeVersion = (data) => write("post", "/api/loan-schemes", data);
export const updateLoanSchemeVersion = (id, data) => write("post", `/api/loan-scheme-versions/${encode(id)}/update`, data);
export const actionLoanSchemeVersion = (id, action, payload = "") => write(
  "post",
  `/api/loan-scheme-versions/${encode(id)}/${encode(action)}`,
  typeof payload === "object" ? payload : { comment: payload },
);
export const listLoanSchemeApprovalWorkflows = () => get("/api/loan-scheme-approval-workflows");
export const createLoanSchemeApprovalWorkflow = (data) => write("post", "/api/loan-scheme-approval-workflows", data);
export const updateLoanSchemeApprovalWorkflow = (id, data) => write("post", `/api/loan-scheme-approval-workflows/${encode(id)}/update`, data);
export const actionLoanSchemeApprovalWorkflow = (id, action) => write("post", `/api/loan-scheme-approval-workflows/${encode(id)}/${encode(action)}`, {});

export const getLoanEnquiryDashboard = () => getObject("/api/loan-enquiries/dashboard");
export const listLoanEnquiries = (filters = {}) => get("/api/loan-enquiries", filters);
export const listLoanApplications = (filters = {}) => get("/api/loan-applications", filters);
export const getLoanApplication = (requestId) => getObject(`/api/loan-applications/${encode(requestId)}`);
export const actionLoanApplication = (requestId, action, data = {}) => write("post", `/api/loan-applications/${encode(requestId)}/${encode(action)}`, data);
export const getIdpDashboard = () => getObject("/api/idp/dashboard");
export const getIdpDocument = id => getObject(`/api/idp/documents/${encode(id)}`);
export const processIdpDocument = id => write("post",`/api/idp/documents/${encode(id)}/process`,{});
export const reviewIdpDocument = (id,data) => write("post",`/api/idp/documents/${encode(id)}/review`,data);
export const unlockIdpDocumentPreview = async (id,pin) => {
  const sessionId = localStorage.getItem("sessionID");
  const actorId = getPortalActorId();
  const response = await loansBackendClient.post("",{pin},{
    params:{route:`/api/idp/documents/${encode(id)}/preview`},
    responseType:"blob",
    headers:sessionId&&actorId?{Authorization:`PAIY-Session ${actorId}:${sessionId}`}:undefined,
  });
  return URL.createObjectURL(response.data);
};
export const getCreditScoringDashboard = () => getObject("/api/credit-scoring/dashboard");
export const listCreditScoringModels = () => get("/api/credit-scoring/models");
export const createCreditScoringModel = data => write("post","/api/credit-scoring/models",data);
export const updateCreditScoringModel = (id,data) => write("post",`/api/credit-scoring/models/${encode(id)}/update`,data);
export const actionCreditScoringModel = (id,action) => write("post",`/api/credit-scoring/models/${encode(id)}/${encode(action)}`,{});
export const saveCreditScoringRule = (id,data) => write("post",id?`/api/credit-scoring/rules/${encode(id)}/update`:"/api/credit-scoring/rules",data);
export const actionCreditScoringRule = (id,action) => write("post",`/api/credit-scoring/rules/${encode(id)}/${encode(action)}`,{});
export const listCreditScoringProviders = () => get("/api/credit-scoring/providers");
export const createCreditScoringProvider = data => write("post","/api/credit-scoring/providers",data);
export const updateCreditScoringProvider = (id,data) => write("post",`/api/credit-scoring/providers/${encode(id)}/update`,data);
export const actionCreditScoringProvider = (id,action) => write("post",`/api/credit-scoring/providers/${encode(id)}/${encode(action)}`,{});
export const runRealtimeCreditScore = data => write("post","/api/credit-scoring/score",data);
export const listCreditScores = () => get("/api/credit-scoring/scores");
export const listCreditScoringBatches = () => get("/api/credit-scoring/batches");
export const createCreditScoringBatch = data => write("post","/api/credit-scoring/batches",data);
export const updateCreditScoringBatch = (id,data) => write("post",`/api/credit-scoring/batches/${encode(id)}/update`,data);
export const actionCreditScoringBatch = (id,action) => write("post",`/api/credit-scoring/batches/${encode(id)}/${encode(action)}`,{});
export const getLoanEnquiryReport = (filters = {}) => getObject("/api/loan-enquiries/report", filters);
export const searchLoanEnquiryCustomers = (search) => get("/api/loan-enquiry-customers", { search });
export const listLoanEnquiryFieldAgents = (filters = {}) => getObject("/api/loan-enquiry-field-agents", filters);
export const getLoanEnquiryErrors = (filters = {}) => getObject("/api/loan-enquiry-errors", filters);
export const getLoanEnquiryNotifications = (filters = {}) => getObject("/api/loan-enquiry-notifications", filters);
export const resolveLoanEnquiryError = (id, notes) => write("post", `/api/loan-enquiry-errors/${encode(id)}/resolve`, { notes });
export const getLoanEnquiry = (id) => getObject(`/api/loan-enquiries/${encode(id)}`);
export const createLoanEnquiry = (data) => write("post", "/api/loan-enquiries", data);
export const runLoanEnquiryScreening = (id) => write("post", `/api/loan-enquiries/${encode(id)}/screen`, {});
export const decideLoanEnquiryReview = (id, data) => write("post", `/api/loan-enquiries/${encode(id)}/manual-review`, data);
export const previewLoanEnquiryQuote = (id, data) => write("post", `/api/loan-enquiries/${encode(id)}/quote-preview`, data);
export const createLoanEnquiryQuote = (id, data) => write("post", `/api/loan-enquiries/${encode(id)}/quotes`, data);
export const queueLoanEnquiryNotification = (id, data) => write("post", `/api/loan-enquiries/${encode(id)}/notifications`, data);
export const convertLoanEnquiry = (id, data) => write("post", `/api/loan-enquiries/${encode(id)}/convert`, data);
export const listLoanEnquiryCustomerProducts = (userId) => get(`/api/users/${encode(userId)}/loan-products`);
export const listLoanEnquiryProductTypes = (productId) => get(`/api/loan-products/${encode(productId)}/types`);
export const listLoanEnquiryPolicies = () => get("/api/loan-enquiry-policies");
export const getLoanEnquiryPolicy = (id) => getObject(`/api/loan-enquiry-policies/${encode(id)}`);
export const createLoanEnquiryPolicy = (data) => write("post", "/api/loan-enquiry-policies", data);
export const updateLoanEnquiryPolicy = (id, data) => write("post", `/api/loan-enquiry-policies/${encode(id)}/update`, data);
export const actionLoanEnquiryPolicy = (id, action, comment = "") => write("post", `/api/loan-enquiry-policies/${encode(id)}/${encode(action)}`, { comment });
export const uploadLoanEnquiryDocument = (id, file, requirementId = "") => { const data = new FormData(); data.append("document", file); if (requirementId) data.append("requirement_id", requirementId); return multipart(`/api/loan-enquiries/${encode(id)}/documents`, data); };
export const actionLoanEnquiryDocument = (id, action, comments = "") => write("post", `/api/loan-enquiry-documents/${encode(id)}/${encode(action)}`, { comments });

const write = async (method, route, data) => {
  const sessionId = localStorage.getItem("sessionID");
  const actorId = getPortalActorId();
  const response = await loansBackendClient.request({
    method,
    url: "",
    params: { route },
    data,
    headers: sessionId && actorId
      ? { Authorization: `PAIY-Session ${actorId}:${sessionId}` }
      : undefined,
  });

  return response?.data?.data || {};
};

const multipart = async (route, formData) => {
  const sessionId = localStorage.getItem("sessionID");
  const actorId = getPortalActorId();
  const response = await loansBackendClient.post("", formData, {
    params: { route },
    headers: {
      "Content-Type": "multipart/form-data",
      ...(sessionId && actorId
        ? { Authorization: `PAIY-Session ${actorId}:${sessionId}` }
        : {}),
    },
  });
  return response?.data?.data || {};
};

// The isolated User Loans components still consume the established record
// envelope. Keep that translation here so the plain-PHP API can retain its
// smaller, consistent HTTP response contract.
const asLegacyReadEnvelope = (records) => ({
  data: {
    header: {
      callStatus: "1",
      reccount: String(records.length),
    },
    body: {
      record: records,
    },
  },
});

export const listProductsAssignedToUsers = async (_queryId, userId) =>
  asLegacyReadEnvelope(
    await get(`/api/users/${encodeURIComponent(userId)}/loan-products`)
  );

export const listAllUserLoanProducts = async (_queryId, userId) =>
  asLegacyReadEnvelope(
    await get(`/api/users/${encodeURIComponent(userId)}/loan-products/available`)
  );

export const listLoanSubProducts = async (_queryId, productId) =>
  asLegacyReadEnvelope(
    await get(`/api/loan-products/${encodeURIComponent(productId)}/types`)
  );

const encode = (value) => encodeURIComponent(value);

const legacyReadRoute = (queryId, value) => {
  const parts = String(value ?? "").split("/");
  const routes = {
    232: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/issued-loans`, { from: parts[2], to: parts[3] }],
    235: [`/api/users/${encode(parts[0])}/loan-payments`, {}],
    236: [`/api/payments/${encode(parts[0])}/applications`, {}],
    237: [`/api/loans/${encode(parts[0])}/applications`, {}],
    239: [`/api/late-fees/${encode(parts[0])}/applications`, {}],
    240: [`/api/loans/${encode(parts[0])}/late-fees`, {}],
    244: [`/api/users/${encode(parts[0])}/loan-request-report`, {}],
    245: [`/api/users/${encode(parts[0])}/loans-due`, { from: parts[1], to: parts[2] }],
    246: [`/api/users/${encode(parts[0])}/loan-age-analysis`, {}],
    247: [`/api/users/${encode(parts[0])}/loan-applications`, {}],
    248: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/limit-history`, {}],
    263: [`/api/loans/${encode(parts[0])}`, {}],
    264: [`/api/loans/${encode(parts[0])}/payments`, {}],
    281: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/cancelled-requests`, {}],
    299: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/requests`, {}],
    349: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/requests/pre-qualification`, {}],
    350: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/requests/pre-qualification-rejected`, {}],
    351: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/requests/underwriting`, {}],
    352: [`/api/users/${encode(parts[0])}/loan-products/${encode(parts[1])}/requests/disbursement`, {}],
  };

  return routes[Number(queryId)] || null;
};

export const commonRunQuery = async (queryId, value) => {
  if (Number(queryId) === 242) {
    return asLegacyReadEnvelope(
      await get(`/api/loan-types/${encode(value)}/payment-terms`)
    );
  }

  const target = legacyReadRoute(queryId, value);
  if (!target) {
    throw new Error(`Unsupported loans-backend query reference: ${queryId}`);
  }
  return asLegacyReadEnvelope(await get(target[0], target[1]));
};

export const getListOfLoansToApprove = (queryId, value) =>
  commonRunQuery(queryId, value);

// New User Loans UI contracts. These return the plain loans-backend payload
// directly so new screens do not need to understand the legacy query envelope.
export const listDisbursementRequests = (userId, productId) =>
  get(
    `/api/users/${encode(userId)}/loan-products/${encode(productId)}/requests/disbursement`
  );

export const listDisbursedLoans = (userId, productId, from, to) =>
  get(
    `/api/users/${encode(userId)}/loan-products/${encode(productId)}/issued-loans`,
    { from, to }
  );

export const cancelDisbursementRequest = (requestId) =>
  write("post", `/api/loan-requests/${encode(requestId)}/cancel`, {});

export const confirmDisbursementRequest = (requestId) =>
  write("post", `/api/loan-requests/${encode(requestId)}/confirm-disbursement`, {});

export const approveDisbursementRequest = (requestId, comment) =>
  write("post", `/api/loan-requests/${encode(requestId)}/approve-disbursement`, {
    comment,
  });

export const getDisbursementReadiness = (requestId) =>
  write("get", `/api/loan-requests/${encode(requestId)}/disbursement-readiness`);

export const uploadDisbursementPrerequisite = (requestId, checkId, file, comments = "") => {
  const data = new FormData();
  data.append("document", file);
  data.append("comments", comments);
  return multipart(`/api/loan-requests/${encode(requestId)}/disbursement-prerequisites/${encode(checkId)}/document`, data);
};

export const updateDisbursementPrerequisite = (requestId, checkId, action, comments = "") =>
  write("post", `/api/loan-requests/${encode(requestId)}/disbursement-prerequisites/${encode(checkId)}/${encode(action)}`, { comments });

export const uploadLoanAgreement = (requestId, file, executionMethod, comments = "") => {
  const data = new FormData();
  data.append("document", file);
  data.append("execution_method", executionMethod);
  data.append("comments", comments);
  return multipart(`/api/loan-requests/${encode(requestId)}/agreements`, data);
};

export const updateLoanAgreement = (requestId, agreementId, action, comments = "") =>
  write("post", `/api/loan-requests/${encode(requestId)}/agreements/${encode(agreementId)}/${encode(action)}`, { comments });

export const downloadLoanAgreement = async (agreementId, fileName = "loan-agreement") => {
  const sessionId = localStorage.getItem("sessionID");
  const actorId = getPortalActorId();
  const response = await loansBackendClient.get("", {
    params: { route: `/api/disbursement-agreements/${encode(agreementId)}/download` },
    responseType: "blob",
    headers: sessionId && actorId
      ? { Authorization: `PAIY-Session ${actorId}:${sessionId}` }
      : undefined,
  });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};

export const getLoanServicingSummary = (userId, loanId) =>
  write(
    "get",
    `/api/users/${encode(userId)}/loans/${encode(loanId)}/servicing-summary`
  );

export const getLoanSettlementQuote = (userId, loanId) =>
  write(
    "get",
    `/api/users/${encode(userId)}/loans/${encode(loanId)}/settlement-quote`
  );

export const getLoanPortfolioHealth = (userId, productId) =>
  write(
    "get",
    `/api/users/${encode(userId)}/loan-products/${encode(productId)}/portfolio-health`
  );

export const getListOfUserPayments = (queryId, value) =>
  commonRunQuery(queryId, value);

const asLegacyMutationEnvelope = (data) => ({
  data: {
    header: { callStatus: "1", errorNo: "", msg: "" },
    body: data,
  },
});

const asLegacyLifecycleEnvelope = (data) => ({
  data: {
    header: {
      callStatus: "1",
      errorNo: "",
      msg: "",
      ...(data?.requestid ? { requestid: data.requestid } : {}),
      ...(data?.requestid ? { loanrequestid: data.requestid } : {}),
      ...(data?.loanid ? { loanid: data.loanid } : {}),
    },
    body: data,
  },
});

export const addLoanLimit = async (
  _location,
  userId,
  productId,
  eligibleLimit,
  status
) => asLegacyMutationEnvelope(
  await write("post", `/api/users/${encodeURIComponent(userId)}/loan-products/${encodeURIComponent(productId)}/limit`, {
    eligible_limit: eligibleLimit,
    status,
  })
);

export const loanLimitEdit = async (
  _location,
  userId,
  productId,
  eligibleLimit,
  status
) => asLegacyMutationEnvelope(
  await write("post", `/api/users/${encodeURIComponent(userId)}/loan-products/${encodeURIComponent(productId)}/limit/update`, {
    eligible_limit: eligibleLimit,
    status,
  })
);

const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null);

const normalizeOutstandingLoan = (loan = {}) => {
  const totalAmountIssued = firstDefined(loan.totalamountissued, loan.totalamount, 0);
  const totalPrincipalPaid = firstDefined(loan.totalprinciplepaid, loan.totalamountapplied, 0);
  const totalFeesPaid = firstDefined(loan.totalfeespaid, loan.totalfeesapplied, 0);
  const totalAmountPaid = firstDefined(loan.totalamountpaid, loan.totalprincipleandfees, 0);
  const principalOutstanding = firstDefined(
    loan.totalprincinpleoutstanding,
    loan.outstandingprinciple,
    0
  );
  const feesOutstanding = firstDefined(loan.totalfeesoutstanding, loan.outstandingfees, 0);
  const totalOutstanding = firstDefined(
    loan.totalamountoutstanding,
    loan.outstandingprincipleandfees,
    0
  );
  const lateFees = firstDefined(loan.outstandinglatefees, 0);
  const outstandingWithLateFees = firstDefined(
    loan.outstandingamountwithlatefee,
    Number(totalOutstanding) + Number(lateFees)
  );

  return {
    ...loan,
    totalprincinpleissued: firstDefined(loan.totalprincinpleissued, loan.issuedamount, 0),
    totalfeesissued: firstDefined(loan.totalfeesissued, loan.totalfees, 0),
    totalamountissued: String(totalAmountIssued),
    totalprinciplepaid: totalPrincipalPaid,
    totalfeespaid: totalFeesPaid,
    totalamountpaid: totalAmountPaid,
    totalprincinpleoutstanding: principalOutstanding,
    totalfeesoutstanding: feesOutstanding,
    totalamountoutstanding: totalOutstanding,
    outstandinglatefees: String(lateFees),
    outstandingamountwithlatefee: String(outstandingWithLateFees),
  };
};

export const checkLoanEligibility = async (
  _location,
  userId,
  productId,
  _sampleLoanType,
  _sampleLoanAmount,
  _sampleLoanAmountForFeeCalculation,
  _sampleTermType,
  _referenceId,
  _returnOutstandingLoans,
  _intent
) => {
  const data = await write(
    "get",
    `/api/users/${encodeURIComponent(userId)}/loan-products/${encodeURIComponent(productId)}/eligibility`
  );
  // Eligibility currently uses the mutation response envelope, which nests
  // the repository result under `loanlimits`. Accept that API shape while
  // retaining support for the earlier direct result during deployments.
  const eligibility = data?.loanlimits || data;
  const limits = Array.isArray(eligibility?.limits) ? eligibility.limits : [];
  const outstandingLoans = Array.isArray(eligibility?.outstanding_loans)
    ? eligibility.outstanding_loans.map(normalizeOutstandingLoan)
    : [];

  return {
    data: {
      header: {
        callStatus: "1",
        errorNo: "",
        msg: "",
        limits: { limit: limits },
      },
      body: {
        outstandingloans: { outstandingloan: outstandingLoans },
      },
    },
  };
};

export const loanOptIn = async (
  _location,
  userId,
  productId,
  referenceId,
  _externalUserId
) => {
  const data = await write(
    "post",
    `/api/users/${encodeURIComponent(userId)}/loan-products/${encodeURIComponent(productId)}/opt-in`,
    { reference_id: referenceId }
  );
  return asLegacyMutationEnvelope({ Loanlimit: data.loanlimit });
};

export const loanOptOut = async (
  _location,
  userId,
  productId,
  referenceId
) => {
  const data = await write(
    "post",
    `/api/users/${encodeURIComponent(userId)}/loan-products/${encodeURIComponent(productId)}/opt-out`,
    { reference_id: referenceId }
  );
  return asLegacyMutationEnvelope({
    Loanlimit: data.loanlimit,
    Loaninfo: data.loaninfo,
  });
};

export const loanRequestOnly = async (
  _location,
  userId,
  productId,
  loanType,
  amount,
  feeCalculationAmount,
  referenceId,
  checkUniqueReference
) => asLegacyLifecycleEnvelope(
  await write(
    "post",
    `/api/users/${encode(userId)}/loan-products/${encode(productId)}/requests`,
    {
      loan_type: loanType,
      amount,
      fee_calculation_amount: feeCalculationAmount,
      reference_id: referenceId,
      check_unique_reference: checkUniqueReference,
    }
  )
);

export const loanRequestOnlyDynamic = async (
  _location,
  userId,
  productId,
  loanType,
  amount,
  feeCalculationAmount,
  referenceId,
  checkUniqueReference,
  issued
) => asLegacyLifecycleEnvelope(
  await write(
    "post",
    `/api/users/${encode(userId)}/loan-products/${encode(productId)}/requests/dynamic`,
    {
      loan_type: loanType,
      amount,
      fee_calculation_amount: feeCalculationAmount,
      reference_id: referenceId,
      check_unique_reference: checkUniqueReference,
      issued,
    }
  )
);

export const loansUpdateRequestStatus = async (
  _location,
  requestId,
  issued
) => asLegacyLifecycleEnvelope(
  await write("post", `/api/loan-requests/${encode(requestId)}/status`, { issued })
);

export const loanRequestCancel = async (_location, requestId) =>
  asLegacyLifecycleEnvelope(
    await write("post", `/api/loan-requests/${encode(requestId)}/cancel`, {})
  );

export const loanApprove = async (
  _location,
  requestId,
  status,
  _approvedBy,
  comment
) => asLegacyLifecycleEnvelope(
  await write("post", `/api/loan-requests/${encode(requestId)}/decision`, {
    status,
    comment,
  })
);

export const loanCancel = async (
  _location,
  userId,
  loanId,
  referenceId,
  reason,
  loanReference
) => asLegacyLifecycleEnvelope(
  await write(
    "post",
    `/api/users/${encode(userId)}/loans/${encode(loanId)}/cancel`,
    {
      reference_id: referenceId,
      reason,
      loan_reference: loanReference,
    }
  )
);

export const loanDisbursementConfirmation = async (_location, userId, loanId) => {
  const data = await write(
    "post",
    `/api/users/${encode(userId)}/loans/${encode(loanId)}/confirm-disbursement`,
    {}
  );
  return {
    data: {
      header: { callStatus: "1", errorNo: "", msg: "", loanid: data.loanid },
      body: data?.loan ? [{ Loanissued: data.loan }] : [],
    },
  };
};

export const loanRequest = async (
  _location,
  userId,
  productId,
  loanType,
  amount,
  feeCalculationAmount,
  referenceId,
  checkUniqueReference,
  paymentTargetDate,
  checkBlockAcrossCurrencies,
  externalUserId,
  otherDetails,
  termType,
  storeLoanRequest
) => {
  try {
    const data = await write(
      "post",
      `/api/users/${encode(userId)}/loan-products/${encode(productId)}/loans`,
      {
        loan_type: loanType,
        amount,
        fee_calculation_amount: feeCalculationAmount,
        reference_id: referenceId,
        check_unique_reference: checkUniqueReference,
        payment_target_date: paymentTargetDate,
        check_block_across_currencies: checkBlockAcrossCurrencies,
        external_user_id: externalUserId,
        other_details: otherDetails,
        term_type: termType,
        store_loan_request: storeLoanRequest,
      }
    );
    return {
      data: {
        header: { callStatus: "1", errorNo: "", msg: "", ...data },
      },
    };
  } catch (error) {
    return {
      Status: "2",
      payload: {
        callStatus: "0",
        msg: error?.response?.data?.message || error?.message || "Loan request failed.",
      },
    };
  }
};

const asLegacyPaymentEnvelope = (data) => ({
  data: {
    header: data?.header || { callStatus: "1", errorNo: "", msg: "" },
    body: data?.body || {},
  },
});

export const loanPaymentPlanRetrieve = async (_location, userId, loanId) => {
  const records = await get(
    `/api/users/${encode(userId)}/loans/${encode(loanId)}/payment-plan`
  );
  return asLegacyReadEnvelope(
    records.map((record) => ({ Loanpaymentplan: record }))
  );
};

export const loanPayment = async (
  _location,
  userId,
  currency,
  amount,
  referenceId,
  checkUniqueReference,
  loanId,
  lateFeesOnly,
  externalUserId
) => asLegacyPaymentEnvelope(
  await write("post", `/api/users/${encode(userId)}/loan-payments`, {
    currency,
    amount,
    reference_id: referenceId,
    check_unique_reference: checkUniqueReference,
    loan_id: loanId,
    late_fees_only: lateFeesOnly,
    external_user_id: externalUserId,
  })
);

export const loanPaymentCancel = async (
  _location,
  userId,
  paymentId,
  paymentReference,
  confirmationReference,
  reason,
  loanIds,
  currency,
  originalRequestId
) => asLegacyPaymentEnvelope(
  await write(
    "post",
    `/api/users/${encode(userId)}/loan-payments/${encode(paymentId)}/cancel`,
    {
      payment_reference: paymentReference,
      confirmation_reference: confirmationReference,
      reason,
      loan_ids: loanIds,
      currency,
      original_request_id: originalRequestId,
    }
  )
);

export const loanPaymentConfirmation7 = async (
  _location,
  userId,
  paymentId,
  paymentReference,
  confirmationReference,
  loanIds,
  currency
) => asLegacyPaymentEnvelope(
  await write(
    "post",
    `/api/users/${encode(userId)}/loan-payments/${encode(paymentId)}/confirm`,
    {
      payment_reference: paymentReference,
      confirmation_reference: confirmationReference,
      loan_ids: loanIds,
      currency,
    }
  )
);

export { loansBackendEntryUrl };
